import React from "react";

import {
    FiBookOpen,
    FiTrendingDown,
    FiTrendingUp,
    FiUsers,
} from "react-icons/fi";

import {
    formatCurrency,
} from "../utils/customerLedgerUtils";

/*
|--------------------------------------------------------------------------
| COMPONENT
|--------------------------------------------------------------------------
*/

const LedgerSummaryCards = ({
    transactionCount = 0,
    customerCount = 0,
    totalDebit = 0,
    totalCredit = 0,
    outstanding = 0,
}) => {
    return (
        <section className="customer-ledger-summary">
            <div className="customer-ledger-summary-card">
                <span className="customer-ledger-summary-icon">
                    <FiBookOpen />
                </span>

                <div>
                    <small>
                        Transactions
                    </small>

                    <strong>
                        {transactionCount}
                    </strong>

                    <p>
                        Total ledger entries
                    </p>
                </div>
            </div>

            <div className="customer-ledger-summary-card">
                <span className="customer-ledger-summary-icon">
                    <FiUsers />
                </span>

                <div>
                    <small>
                        Customers
                    </small>

                    <strong>
                        {customerCount}
                    </strong>

                    <p>
                        With ledger activity
                    </p>
                </div>
            </div>

            <div className="customer-ledger-summary-card customer-ledger-summary-debit">
                <span className="customer-ledger-summary-icon">
                    <FiTrendingUp />
                </span>

                <div>
                    <small>
                        Total Debit
                    </small>

                    <strong>
                        {formatCurrency(
                            totalDebit
                        )}
                    </strong>

                    <p>
                        Sales / receivable
                    </p>
                </div>
            </div>

            <div className="customer-ledger-summary-card customer-ledger-summary-credit">
                <span className="customer-ledger-summary-icon">
                    <FiTrendingDown />
                </span>

                <div>
                    <small>
                        Total Credit
                    </small>

                    <strong>
                        {formatCurrency(
                            totalCredit
                        )}
                    </strong>

                    <p>
                        Payments / credits
                    </p>
                </div>
            </div>

            <div className="customer-ledger-summary-card customer-ledger-summary-outstanding">
                <span className="customer-ledger-summary-icon">
                    ₹
                </span>

                <div>
                    <small>
                        Outstanding
                    </small>

                    <strong>
                        {formatCurrency(
                            outstanding
                        )}
                    </strong>

                    <p>
                        Current receivable
                    </p>
                </div>
            </div>
        </section>
    );
};

export default LedgerSummaryCards;